import type { Persona } from "./types";

export interface WorkbookInfo {
  filename: string;
  sheetNames: string[];
}

export async function getWorkbookInfo(): Promise<WorkbookInfo> {
  return Excel.run(async (context) => {
    const wb = context.workbook;
    const sheets = wb.worksheets;
    wb.load("name");
    sheets.load("items/name");
    await context.sync();
    return {
      filename: wb.name,
      sheetNames: sheets.items.map((s) => s.name),
    };
  });
}

/** Returns true if the persona's autoMatch criteria match the workbook. */
export function matchPersona(persona: Persona, info: WorkbookInfo): boolean {
  const m = persona.autoMatch;
  if (!m) return false;
  const filenameNeedle = m.filenameSubstring?.trim().toLowerCase();
  const sheetNeedle = m.sheetNameSubstring?.trim().toLowerCase();
  if (!filenameNeedle && !sheetNeedle) return false;

  if (filenameNeedle && info.filename.toLowerCase().includes(filenameNeedle)) {
    return true;
  }
  if (sheetNeedle && info.sheetNames.some((n) => n.toLowerCase().includes(sheetNeedle))) {
    return true;
  }
  return false;
}

/**
 * Return the first persona (in array order) whose autoMatch criteria match
 * the workbook, or null if none match.
 */
export async function detectPersona(personas: Persona[]): Promise<Persona | null> {
  const candidates = personas.filter((p) => p.autoMatch !== undefined);
  if (candidates.length === 0) return null;
  const info = await getWorkbookInfo();
  for (const p of candidates) {
    if (matchPersona(p, info)) return p;
  }
  return null;
}
